import * as universal from "../../../../src/routes/[prefix]/+page.ts";
export { universal };